import React, { lazy, Suspense, useEffect, useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { GridList } from '@material-ui/core';
import { logEvent } from '../../log/logUtil';
import { getPostsById } from '../../api/reddit';
import './Favorites.css';
const RedditPostImg = lazy(() => import('../RedditPostImg/RedditPostImg'));
const GridListTile = lazy(() => import('@material-ui/core/GridListTile'));
const Link = lazy(() => import('react-router-dom/Link'));

const NUM_COLS = 3;

const tileStyle = {
    height: `calc((100vw) / ${NUM_COLS})`,
    flexBasis: 'calc(33.333333% - 4px)', // Subtract 2 * (horizontal margin)
    margin: '2px'
};

const Favorites = (props) => {
    logEvent('screen_view', {
        firebase_screen: 'Favorites'
    });

    const { favorites } = props;

    const [posts, setPosts] = useState([]);

    useEffect(() => {
        (async () => {
            const posts = await getPostsById(favorites);
            setPosts(posts);
        })();
    }, [favorites]);

    return (
        <div className='container'>
            <AppBar position='static'>
                <Toolbar style={{ flexGrow: 1 }}>
                    <Typography variant='h6' >
                        Favorites
                    </Typography>
                </Toolbar>
            </AppBar>
            <GridList spacing={0} cols={NUM_COLS} className='GridList'>
                {
                    posts.map(post =>
                        <Suspense fallback={<div />} key={post.id}>
                            <GridListTile style={tileStyle} cols={1}>
                                <Link
                                    to={`/posts/${post.id}`}
                                    onClick={() => {
                                        logEvent('select_content', {
                                            content_type: 'Post'
                                        });
                                    }}>

                                    <RedditPostImg
                                        post={post}
                                        className='img'
                                        mediaQueryFunc={resolution =>
                                            `(min-width: ${resolution.width}px) calc(100vw / ${NUM_COLS})`}
                                    />
                                </Link>
                            </GridListTile>
                        </Suspense>
                    )
                }
            </GridList>
        </div >
    );
};

export default Favorites;